import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { tableLoadData } from '../actions/ListTableActions';
import { getAssetType } from '../../asset-types/redux/selectors/AssetTypesSelectors';
import { setAssetTypeSelectionActionCreator } from '../../asset-types/redux/actions/AssetTypesActions';
import TableDefinitions from '../../TableDefinitions';
import UserListingContainer from '../../../application/user-management/list/containers/UserListingContainer';
import ImpcDetailsContainer from '../../../application/impc-details/containers/ImpcDetailsContainer';
import YearlyThresholdsContainer from '../../../application/yearly-thresholds/containers/YearlyThresholdsContainer';
import RouteManagementContainer from '../../../application/route-management/containers/RouteManagementContainer';
import ImpcStockLevelsContainer from '../../../application/impc-stock-levels/containers/ImpcStockLevelsContainer';
import InternalRepatriationsTransactionsContainer
  from '../../../application/impc-stock-levels/transactions/internal-repatriations/containers/InternalRepatriationsTransactionsContainer';
import ImpcStockLevelsAlertsTableContainer
  from '../../../application/impc-stock-levels/containers/ImpcStockLevelsAlertsTableContainer';
import ImpcStockLevelsCentralEntryPointTableContainer
  from '../../../application/impc-stock-levels/containers/ImpcStockLevelsCentralEntryPointTableContainer';
import CenterInitiatedRepatriationsTransactionsContainer
  from '../../../application/impc-stock-levels/transactions/internal-repatriations/containers/CenterInitiatedRepatriationsTransactionsContainer';
import ManualPreadviceTransactionsContainer
  from '../../../application/impc-stock-levels/transactions/manual-preadvice/containers/ManualPreadviceTransactionsContainer';
import BalanceModificationTransactionsContainer
  from '../../../application/impc-stock-levels/transactions/balance-modification/containers/BalanceModificationTransactionsContainer';
import BalanceOnHandCurrentInfoContainer
  from '../../../application/impc-stock-levels/impc-characteristics/boh-info/containers/BalanceOnHandCurrentInfoContainer';
import BalanceOnHandExpectedInfoContainer
  from '../../../application/impc-stock-levels/impc-characteristics/boh-info/containers/BalanceOnHandExpectedInfoContainer';
import BalanceOnHandRouteInfoContainer
  from '../../../application/impc-stock-levels/impc-characteristics/boh-info/containers/BalanceOnHandRouteInfoContainer';
import BalanceOnHandPastInfoContainer
  from '../../../application/impc-stock-levels/impc-characteristics/boh-historic/containers/BalanceOnHandPastInfoContainer';
import RouteModificationTransactionsContainer
  from '../../../application/impc-stock-levels/transactions/route-modification/containers/RouteModificationTransactionsContainer';
import BalanceOnHandReportContainer
  from '../../../application/reporting/balance-on-hand/containers/BalanceOnHandReportContainer';
import FluxVolumeOeReportContainer from '../../../application/reporting/flux-volume-oe/containers/FluxVolumeOeReportContainer';
import FluxVolumeOperatorReportContainer from '../../../application/reporting/flux-volume-operator/containers/FluxVolumeOperatorReportContainer';
import InternalRepatriationReportContainer from '../../../application/reporting/internal-repatriation/containers/InternalRepatriationReportContainer';
import CenterInitiatedRepatriationReportContainer from '../../../application/reporting/center-initiated-repatriation/containers/CenterInitiatedRepatriationReportContainer';
import TotalPoolBreakdownReportContainer from '../../../application/reporting/total-pool-breakdown/containers/TotalPoolBreakdownReportContainer';
import RfidMovementCountReportContainer from '../../../application/reporting/rfid-movement-count/containers/RfidMovementCountReportContainer';
import RfidOnRouteReportContainer from '../../../application/reporting/rfid-on-route/containers/RfidOnRouteReportContainer';
import ViewTransactionsPageContainer from '../../../application/transaction-management/view-transaction/containers/ViewTransactionsPageContainer';
import ViewTransactionHistoryContainer from '../../../application/transaction-management/view-transaction-history/containers/ViewTransactionHistoryContainer';
import RfidOnRouteNonConsolidatedReportContainer from '../../../application/reporting/rfid-on-route/rfid-on-route-non-consolidated/containers/RfidOnRouteNonConsolidatedReportContainer';
import EdiRfidAuditRequestListContainer
  from '../../../application/edi-rfid-audit/request/containers/EdiRfidAuditRequestListContainer';
import EdiRfidAuditRequestExecutionListContainer
  from '../../../application/edi-rfid-audit/execution/containers/EdiRfidAuditRequestExecutionListContainer';
import RfidUploadedFilesListContainer from '../../../application/rfid-file-management/containers/RfidUploadedFilesListContainer';
import RfidFilesErrorsContainer from '../../../application/rfid-file-management/errors/containers/RfidFilesErrorsContainer';
import DailyRouteLeadingCountStatusListContainer
  from '../../../application/daily-route-leading-count-status/containers/DailyRouteLeadingCountStatusListContainer';
import DailyRouteLeadingCountContainer from '../../../application/reporting/daily-route-leading-count/containers/DailyRouteLeadingCountContainer';
import MemberPoolStorageListContainer from '../../../application/member-pool-storage/container/MemberPoolStorageListContainer';
import BalanceOnHandThresholdsContainer from '../../../application/impc-stock-levels/impc-characteristics/boh-thresholds/containers/BalanceOnHandThresholdsContainer';
import RecalculateTasksContainer from '../../../application/recalculate-tasks/containers/RecalculateTasksContainer';

export class ListTableContainer extends Component {
  render() {
    switch (this.props.tableId) {
      case TableDefinitions.USER_LIST_PAGE.id:
      case TableDefinitions.RFID_UPLOADED_FILES_LIST.id:
      case TableDefinitions.EDI_RFID_AUDIT_REQUESTS_LIST_PAGE.id:
      case TableDefinitions.EDI_RFID_AUDIT_REQUEST_EXECUTION_REPORT.id:
        this.props.tableLoadData({ tableId: this.props.tableId }, this.props.appContext.appContext);
        break;
      default:
    }

    switch (this.props.tableId) {
      case TableDefinitions.USER_LIST_PAGE.id:
        return <UserListingContainer {...this.props} />;
      case TableDefinitions.IMPC_DETAILS_PAGE.id:
        return <ImpcDetailsContainer {...this.props} />;
      case TableDefinitions.YEARLY_THRESHOLDS_PAGE.id:
        return <YearlyThresholdsContainer {...this.props} />;
      case TableDefinitions.ROUTE_MANAGEMENT_PAGE.id:
        return <RouteManagementContainer {...this.props} />;
      case TableDefinitions.IMPC_STOCK_LEVELS_ALL_LIST.id:
        return <ImpcStockLevelsContainer {...this.props} />;
      case TableDefinitions.IMPC_STOCK_LEVELS_WITH_ALERTS_LIST.id:
        return <ImpcStockLevelsAlertsTableContainer {...this.props} />;
      case TableDefinitions.IMPC_STOCK_LEVELS_WITH_CENTRAL_ENTRY_POINT.id:
        return <ImpcStockLevelsCentralEntryPointTableContainer {...this.props} />;
      case TableDefinitions.INTERNAL_REPATRIATIONS_TRANSACTIONS.id:
        return <InternalRepatriationsTransactionsContainer {...this.props} />;
      case TableDefinitions.CENTER_INITIATED_REPATRIATIONS.id:
        return <CenterInitiatedRepatriationsTransactionsContainer {...this.props} />;
      case TableDefinitions.MANUAL_PREADVICE_TRANSACTIONS.id:
        return <ManualPreadviceTransactionsContainer {...this.props} />;
      case TableDefinitions.BALANCE_MODIFICATION_TRANSACTIONS.id:
        return <BalanceModificationTransactionsContainer {...this.props} />;
      case TableDefinitions.VIEW_BOH_CURRENT_INFO.id:
        return <BalanceOnHandCurrentInfoContainer {...this.props} />;
      case TableDefinitions.BALANCE_ON_HAND_THRESHOLDS_PAGE.id:
        return <BalanceOnHandThresholdsContainer {...this.props} />;
      case TableDefinitions.VIEW_BOH_EXPECTED_INFO.id:
        return <BalanceOnHandExpectedInfoContainer {...this.props} />;
      case TableDefinitions.VIEW_BOH_ROUTE_INFO.id:
        return <BalanceOnHandRouteInfoContainer {...this.props} />;
      case TableDefinitions.VIEW_BOH_PAST_INFO.id:
        return <BalanceOnHandPastInfoContainer {...this.props} />;
      case TableDefinitions.ROUTE_MODIFICATION_TRANSACTIONS.id:
        return <RouteModificationTransactionsContainer {...this.props} />;
      case TableDefinitions.REPORTING_BALANCE_ON_HAND_PAGE.id:
        return <BalanceOnHandReportContainer {...this.props} />;
      case TableDefinitions.MEMBER_POOL_STORAGE_PAGE.id:
        return <MemberPoolStorageListContainer {...this.props} />;
      case TableDefinitions.REPORTING_FLUX_VOLUME_OE.id:
        return <FluxVolumeOeReportContainer {...this.props} />;
      case TableDefinitions.REPORTING_FLUX_VOLUME_OPERATOR.id:
        return <FluxVolumeOperatorReportContainer {...this.props} />;
      case TableDefinitions.REPORTING_INTERNAL_REPATRIATIONS.id:
        return <InternalRepatriationReportContainer {...this.props} />;
      case TableDefinitions.REPORTING_CENTER_INITIATED_REPATRIATIONS.id:
        return <CenterInitiatedRepatriationReportContainer {...this.props} />;
      case TableDefinitions.REPORTING_TOTAL_POOL_BREAKDOWN.id:
        return <TotalPoolBreakdownReportContainer {...this.props} />;
      case TableDefinitions.REPORTING_RFID_MOVEMENT_COUNT.id:
        return <RfidMovementCountReportContainer {...this.props} />;
      case TableDefinitions.REPORTING_RFID_ON_ROUTE.id:
        return <RfidOnRouteReportContainer {...this.props} />;
      case TableDefinitions.TRANSACTION_MANAGEMENT.id:
        return <ViewTransactionsPageContainer {...this.props} />;
      case TableDefinitions.TRANSACTION_HISTORY.id:
        return <ViewTransactionHistoryContainer {...this.props} />;
      case TableDefinitions.REPORTING_RFID_ON_ROUTE_NON_CONSOLIDATED.id:
        return <RfidOnRouteNonConsolidatedReportContainer {...this.props} />;
      case TableDefinitions.EDI_RFID_AUDIT_REQUESTS_LIST_PAGE.id:
        return <EdiRfidAuditRequestListContainer {...this.props} />;
      case TableDefinitions.EDI_RFID_AUDIT_REQUEST_EXECUTIONS.id:
        return <EdiRfidAuditRequestExecutionListContainer {...this.props} />;
      case TableDefinitions.RFID_UPLOADED_FILES_LIST.id:
        return <RfidUploadedFilesListContainer {...this.props} />;
      case TableDefinitions.RFID_FILES_ERRORS_LIST.id:
        return <RfidFilesErrorsContainer {...this.props} />;
      case TableDefinitions.DAILY_ROUTE_LEADING_COUNT_STATUS_PAGE.id:
        return <DailyRouteLeadingCountStatusListContainer {...this.props} />;
      case TableDefinitions.DAILY_ROUTE_LEADING_COUNT_SUMMARY.id:
        return <DailyRouteLeadingCountContainer {...this.props} />;
      case TableDefinitions.RECALCULATE_TASKS_LIST.id:
        return <RecalculateTasksContainer {...this.props} />;
      default:
        return <div>Page not found</div>;
    }
  }
}

ListTableContainer.propTypes = {
  data: PropTypes.arrayOf(PropTypes.object),
  tableLoadData: PropTypes.func,
  appContext: PropTypes.objectOf(PropTypes.shape),
  tableId: PropTypes.string,
};

function mapStateToProps(state) {
  return {
    appContext: getAssetType(state),
  };
}

const mapDispatchToProps = (dispatch) => bindActionCreators({
  tableLoadData,
  setAssetTypeSelectionActionCreator,
}, dispatch);

export default connect(mapStateToProps, mapDispatchToProps)(ListTableContainer);
